<script>
  import { Link } from "svelte-routing";
  import { auth, db } from "../../helpers/firebase.js";

  import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Label,
    Input,
    Form,
    Button,
  } from "sveltestrap";

  const passwordResetForm = ({
		target: {
			elements: { email },
		},
	}) => {
    auth
      .sendPasswordResetEmail(email.value)
      .then(() => {
        alert("비밀번호 초기화 이메일이 발송되었습니다.")
      })
      .catch((error) => {
        alert("비밀번호 초기화에 실패하였습니다. 관리자(klaid@lawcompany.co.kr)에게 문의주세요.")
      });
  };
</script>

<div class="account-pages my-5 pt-sm-5">
  <Container>
    <Row class="justify-content-center">
      <Col md={8} lg={6} xl={5}>
        <Card class="overflow-hidden">
          <div class="bg-primary bg-soft">
            <Row>
              <Col xs={7}>
                <div class="text-primary p-4">
                  <h5 class="text-primary">비밀번호 초기화</h5>
                  <p />
                </div>
              </Col>
              <!-- <Col xs={5} class="align-self-end">
                <img
                  src="assets/images/profile-img.png"
                  alt=""
                  class="img-fluid"
                />
              </Col> -->
            </Row>
          </div>
          <CardBody class="pt-0">
            <div>
              <Link to="dashboard">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img
                      src="assets/images/klaid-logo.svg"
                      alt=""
                      class="rounded-circle"
                      height="34"
                    />
                  </span>
                </div>
              </Link>
            </div>

            <div class="p-2">
              <div class="alert alert-success text-center mb-4" role="alert">
                등록하신 이메일을 입력하시면 비밀번호 초기화 메일을
                발송드립니다.
              </div>

              <Form class="form-horizontal" action="/">
                <div class="mb-3">
                  <Label for="useremail" class="form-label">이메일</Label>
                  <Input
                    type="email"
                    class="form-control"
                    id="useremail"
                    placeholder="이메일을 입력하세요"
                  />
                </div>

                <div class="text-end">
                  <Button
                    color="primary"
                    class="w-md waves-effect waves-light"
                    type="submit"
                    on:click={passwordResetForm}>초기화</Button
                  >
                </div>
              </Form>
            </div>
          </CardBody>
        </Card>
        <div class="mt-5 text-center">
          <p>
            <!-- 로그인 하러가기{" "} -->
            <Link to="login" class="fw-medium text-primary">
              {" "}
              로그인으로 돌아가기
            </Link>{" "}
          </p>
          <p>
            © {new Date().getFullYear()} LAW&COMPANY.
          </p>
        </div>
      </Col>
    </Row>
  </Container>
</div>
